enum UserAction {
  REMOVE = "remove",
  ADD = "add",
}

export default UserAction;
